import http from '../_httpHandlers';
import { config } from '../_config';
import { IInstallServices, IServices, IUpdateService } from '../_types/interfaces';

const uri = config.backendAddress;

const getServices = async (): Promise<IServices> => {
    return await http.get(`${uri}/updates`);
};

const updateServices = async (services: IInstallServices): Promise<void> => {
    return await http.post(`${uri}/updates`, services);
};

export const updateService: IUpdateService = {
    getServices,
    updateServices,
};